import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.scss';
import { AuthContext } from '../context/auth/authState';
import { ContactContext, EventsContext, LanguageContext } from '../context';
import { AUTH_PROMPT_TYPE } from '../utils/constants';
import { Person, PersonOutline } from '@mui/icons-material';

function Header() {
  const { authStateLoaded, isUserAuthenticated, promptAuth } = useContext(AuthContext)
  const { promptCreateEvent } = useContext(EventsContext)
  const { t } = useContext(LanguageContext)
  const [showSidebar, setShowSidebar] = useState(false);

  const { openContactModal } = useContext(ContactContext)

  useEffect(() => {
    if (showSidebar) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    // Cleanup function to remove the class when the component unmounts
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [showSidebar]);

  return (
    <>
      <div className={'overlay' + (showSidebar ? ' display' : '')} onClick={() => setShowSidebar(false)}></div>
      <div className={'sidebar w-72 md:w-80 h-full bg-indigo-700 text-white p-6' + (showSidebar ? ' display' : '')}>
        <Link to="/" onClick={() => setShowSidebar(false)} className='home-page-link'>WeCar</Link>
        <div className='lg:hidden'>
          <button onClick={promptCreateEvent} className='light w-full mt-4'>
            {`+ ${t('event.create_button')}`}
          </button>

          {authStateLoaded && !isUserAuthenticated && <ul>
            <li><a onClick={() => { promptAuth(AUTH_PROMPT_TYPE.LOGIN); setShowSidebar(false) }}>{t('auth.connect')}</a></li>
            <li><a onClick={() => { promptAuth(AUTH_PROMPT_TYPE.SIGNUP); setShowSidebar(false) }}>{t('auth.sign_up')}</a></li>
          </ul>}
        </div>
        {authStateLoaded && isUserAuthenticated && <div className='lg:hidden'>
          <div className='separator'></div>
          <ul>
            <li><Link to="/my-events" onClick={() => setShowSidebar(false)}>{t('header.my_events')}</Link></li>
            {/* <li><Link to="/co2" onClick={() => setShowSidebar(false)}>{t('header.my_impact')}</Link></li> */}
          </ul>
        </div>}
        <div className='separator'></div>
        <ul className='mb-8'>
          <li><Link to="/" onClick={() => setShowSidebar(false)}>{t('header.home')}</Link></li>
          <li><Link to="/about" onClick={() => setShowSidebar(false)}>{t('header.about')}</Link></li>
          <li><Link to="/faq" onClick={() => setShowSidebar(false)}>{t('header.faq')}</Link></li>
          <li><Link to="#" onClick={() => {
            openContactModal()
            setShowSidebar(false)
          }}>{t('header.contact')}</Link></li>
        </ul>
        <ul>
          <li><a target='_blank' className='small mb-2' rel='noreferrer' download href={'/CGU_Application WeCar.pdf'} onClick={() => setShowSidebar(false)}>{t('footer.cgu_application')}</a></li>
          <li><a target='_blank' className='small mb-2' rel='noreferrer' download href={'/CGU_Service_WeCar.pdf'} onClick={() => setShowSidebar(false)}>{t('footer.cgu_service')}</a></li>
          <li><a target='_blank' className='small mb-2' rel='noreferrer' download href={'/Politique de confidentialité_WeCar.pdf'} onClick={() => setShowSidebar(false)}>{t('footer.privacy_policy')}</a></li>
          <li><a target='_blank' className='small mb-2' rel='noreferrer' download href={'/Politique Cookies_WeCar.pdf'} onClick={() => setShowSidebar(false)}>{t('footer.cookies_policy')}</a></li>
        </ul>
      </div>
      <div className='flex justify-between items-center max-w-7xl mx-auto py-6 p-4 relative mb-10 lg:mb-16'>
        <div className='flex gap-2 lg:gap-8'>
          <button onClick={() => setShowSidebar(!showSidebar)} className='p-0 bg-white'>
            <img src='/menu.svg' />
          </button>
          <div className='flex gap-4'>
            {authStateLoaded && isUserAuthenticated && <Link to={'/my-events'} className='header-links'>
              <img src='/calendar.svg' />
              <span className='hidden lg:flex'> {t('header.my_events')}</span>
            </Link>}
            {/* <Link to={'/co2'} className='header-links'>
              <img src='/nature.svg' />
              {t('header.my_impact')}
            </Link> */}
          </div>
        </div>
        <Link to={'/'} className='absolute left-2/4 top-6 -translate-x-2/4'>
          <img alt='logo' src='/JPG_1.jpg' className='w-28 lg:w-36 px-2 lg:px-1' />
        </Link>

        <div className='flex items-center gap-2 lg:gap-4'>
          <div className='flex flex-col gap-3'>
            <button onClick={promptCreateEvent} className='!px-3 !lg:px-3.5'>
              <img src='/add.svg' />
              <span className='hidden lg:flex'>{t('event.create_button')}</span>
            </button>
            {authStateLoaded && !isUserAuthenticated && <div className='hidden lg:block'>
              <a className='cursor-pointer link' onClick={() => promptAuth(AUTH_PROMPT_TYPE.LOGIN)}>{t('auth.connect')}</a>
              <span className='mx-4 link-separator'></span>
              <a className='cursor-pointer link' onClick={() => promptAuth(AUTH_PROMPT_TYPE.SIGNUP)}>{t('auth.sign_up')}</a>
            </div>}
          </div>
          {isUserAuthenticated && <Link to={'/my-profile'}>
            <span className='flex justify-center items-center w-9 h-9 rounded-full my-profile'>
              <PersonOutline />
            </span>
          </Link>}
        </div>
      </div>

    </>

  )
}

export default Header
